import styles from './styles.module.sass';
import { Params } from '@ui/params';
import { formatBagId } from '@lib/bag-formatting';
import { UiTextField } from '@@/ui/components/ui-text-field';
import { DatePicker } from '@consta/uikit/DatePicker';
import { ModalDialog } from '@ui/modal-dialog';
import { useStore } from '@lib/state-engine';
import {
  $agriculture,
  $agricultureById,
  $agricultureModalIdEnable,
  $agricultureIsLoading,
} from '@@/agriculture/store/agriculture.store';
import { useId, useState } from 'react';
import { useImmer } from 'use-immer';
import { FILL_BAG_DEFAULT_INPUTS } from '@features/fill-bag/constants';
import { DATE_TIME_ISO_FORMAT, dateFormatter } from '@lib/date-formatting';
import { IFillWarehouseBagData } from '@@/bags/ts';
import {
  $isFillingWarehouseBag,
  $warehouseId,
  fillWarehouseBag,
  useBag,
} from '@entities/warehouse/store';
import { onChangeByValuesFn } from '@@/common/ts';
import { setByValues } from '@@/common/utils/set-by-values.util';
import { UiButton } from '@@/ui/components/ui-button';

export function FillBagModal({
  id,
  // title,
  onClose,
}: // agricultureIsLoading = true,
{
  id: string;
  // title: string;
  onClose: () => void;
  // actions: JSX.Element;
  // agricultureIsLoading: boolean;
}) {
  const fillWarehouseBagLocal = fillWarehouseBag;
  const formId = useId();
  const agricultureById = useStore($agricultureById);
  const [, edit] = useStore($agricultureModalIdEnable);
  const isLoading = useStore($isFillingWarehouseBag);
  const warehouseId = useStore($warehouseId);
  const agriculture = useStore($agriculture);
  const agricultureIsLoading = useStore($agricultureIsLoading);
  const bag = useBag(id);
  const [selectedCulture, setSelectedCulture] = useState<number | null>(
    bag.agricultureId || null,
  );

  const title = !selectedCulture ? 'Выберите культуру' : 'Информация о хранилище';

  const startInputs = {
    ...FILL_BAG_DEFAULT_INPUTS,
    weight: bag?.weight ? bag.weight.toString() : FILL_BAG_DEFAULT_INPUTS.weight,
  };
  if (bag?.values?.length && bag?.agricultureId) {
    let parameters = agricultureById[bag.agricultureId].parameters;
    if (parameters) {
      startInputs.parameters = bag.values.reduce(
        (acc: { [key: number]: string }, val) => {
          if (val.value === null) return acc;
          let id = parameters.find((p) => p.name == val.name)?.id;
          if (!id) return acc;
          acc[id] = val.value;

          return acc;
        },
        {},
      );
    }
  }
  const [inputs, setInputs] = useImmer(startInputs);

  const onSelectCulture = (id: number) => {
    setSelectedCulture(id);
    setInputs((draft) => {
      draft.parameters = agricultureById[id].parameters.reduce(
        (acc, parameter) => ({
          ...acc,
          [parameter.id]: String(parameter.options.min ?? 0),
        }),
        {} as Record<number, string>,
      );
    });
  };

  const onChangeInput: onChangeByValuesFn = (values) => {
    setInputs((draft) => void setByValues(draft, values));
  };

  function onSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const data = {
      agriculture_id: selectedCulture,
      warehouse_id: warehouseId,
      weight: Number(inputs.weight),
      filling_date: dateFormatter(inputs.fillDate).format(DATE_TIME_ISO_FORMAT),
      parameters: Object.entries(inputs.parameters).reduce((acc, [id, value]) => {
        const parameterIndex = agricultureById[
          selectedCulture as number
        ].parameters.findIndex((parameter) => parameter.id === +id);
        // TODO: после привязки к ид, изменить
        const parameterName =
          agricultureById[selectedCulture as number].parameters[parameterIndex].name;

        return {
          ...acc,
          [parameterName]: value,
        };
      }, {}),
    } as IFillWarehouseBagData;
    fillWarehouseBagLocal({
      bagId: id,
      data,
    });
  }

  const actions = !selectedCulture ? (
    <></>
  ) : (
    <UiButton
      label={edit ? 'Редактировать' : 'Добавить'}
      view="primary"
      type="submit"
      loading={isLoading}
      htmlForm={formId}
    />
  );

  return (
    <ModalDialog
      className={styles.modal}
      title={title}
      onClose={onClose}
      actions={actions}
      loading={agricultureIsLoading}
    >
      {!selectedCulture && (
        <div className={styles.agriculture}>
          {agriculture.map((agriculture) => (
            <button
              key={agriculture.id}
              className={styles.cultureButton}
              onClick={() => onSelectCulture(agriculture.id)}
            >
              <div>{agriculture.name}</div>
              <img src={agriculture.img} alt={agriculture.name} />
            </button>
          ))}
        </div>
      )}

      {selectedCulture && (
        <div className={styles.content}>
          <Params
            className={styles.cultureParameters}
            list={[
              {
                label: 'культура:',
                value: agricultureById[selectedCulture].name,
              },
              { label: 'ID хранилища:', value: formatBagId(id) },
            ]}
          />

          <form className={styles.form} id={formId} onSubmit={onSubmit}>
            {agricultureById[selectedCulture].parameters.map((parameter) => {
              return (
                <UiTextField
                  key={parameter.id}
                  label={`${parameter.name} (${parameter.units})`}
                  type="number"
                  value={inputs.parameters[parameter.id]}
                  required
                  min={parameter.options.min ?? 0}
                  max={parameter.options.max}
                  onChange={({ value }) =>
                    onChangeInput({ [`parameters.${parameter.id}`]: value })
                  }
                />
              );
            })}

            <UiTextField
              label="Вес (т)"
              type="number"
              value={inputs.weight}
              required
              min={1}
              onChange={({ value }) => onChangeInput({ weight: value })}
            />
            <DatePicker
              dropdownClassName={styles.pickerDropdown}
              label="Дата заполнения"
              required
              value={inputs.fillDate}
              onChange={({ value }) => onChangeInput({ fillDate: value })}
            />
          </form>
        </div>
      )}
    </ModalDialog>
  );
}
